// extracted by mini-css-extract-plugin
export default {"root":"ChatMessageText_root__Fjakw","outgoingMessage":"ChatMessageText_outgoingMessage__4itDG","mention":"ChatMessageText_mention__NdbX1"};